import initialState from '../initialState'

export function updateUserDetails(state = initialState.user, action) {
  switch (action.type) {
    case 'SET_USER':
      return Object.assign({}, state, action.user)
    default:
      return state
  }
}

export function updateUserPermissionForFolder(
  state = initialState.userPermission,
  action,
) {
  switch (action.type) {
    case 'SET_USER_PERMISSION_FOR_FOLDER':
      return action.userPermission
    default:
      return state
  }
}

export function updateActiveMenu(state = initialState.activeMenu, action) {
  switch (action.type) {
    case 'SET_ACTIVE_MENU':
      return action.activeMenu
    default:
      return state
  }
}

export default {
  updateUserDetails,
  updateUserPermissionForFolder,
  updateActiveMenu,
}
